import * as React from "react";
import type { SVGProps } from "react";
const SvgUserProfileSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeWidth={2}
      d="M4.2 19.8c.344-.385 2.658-2.202 3.808-3.098A2.38 2.38 0 0 1 9.47 16.2h5.047c.537 0 1.056.183 1.489.502 1.484 1.093 2.876 1.908 4.393 3.098M6 21.6h12a3.6 3.6 0 0 0 3.6-3.6V6A3.6 3.6 0 0 0 18 2.4H6A3.6 3.6 0 0 0 2.4 6v12A3.6 3.6 0 0 0 6 21.6Zm9.439-12.328c0-1.831-1.547-3.328-3.439-3.328S8.561 7.441 8.561 9.272c0 1.832 1.547 3.328 3.439 3.328s3.439-1.496 3.439-3.328Z"
    />
  </svg>
);
export default SvgUserProfileSquare;
